<template>
    <div>
        <modal-new-competition-poomsae></modal-new-competition-poomsae>



        <div class="content-wrapper" v-if="!loadingComplete()">
            <section class="content">
                <div class="col-md-12">
                    <div class="box box-primary">
                        <div class="box-header">
                            <h3 class="box-title">Chargement en cours</h3>
                        </div>
                        <div class="box-body">
                            Chargement de la competition Poomsae
                        </div>
                        <div class="overlay">
                            <i class="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <div class="content-wrapper" v-if="loadingComplete()">
            <!-- Content Header (Page header) -->
            <section class="content-header" v-if="competition_id!=0">
                <h1>
                    {{getCompetitionPoomsae.competition}}
                    <small>Compétition Poomsae · {{getCompetitionPoomsae.participations.length}} compétiteurs</small>
                </h1>
                <ol class="breadcrumb">
                    <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
                    <li><a href="#">Compétitions Poomsae</a></li>
                    <li class="active"><a href="#">#{{getCompetitionPoomsae.competition}}</a></li>
                </ol>
            </section>

            <section class="content-header" v-if="competition_id==0">
                <h1>
                    Compétitions Poomsae
                    <small>Gestion dédiée</small>
                </h1>
                <ol class="breadcrumb">
                    <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
                    <li class="active"><a href="#">Compétitions Poomsae</a></li>
                </ol>
            </section>

            <section class="content">
                <div class="row">
                    <div class="col-md-12">
                        <div class="nav-tabs-custom nav-tabs-custom-bottom">
                            <ul class="nav nav-tabs" role="tablist">
                                <li :class="{ 'active': competition_id!=0 }" v-if="competition_id!=0">
                                    <a href="#member_tab_1"
                                       aria-controls="#member_tab_1"
                                       data-toggle="tab"
                                       aria-expanded="false">Fiche de la compétition Poomsae</a>
                                </li>

                                <li :class="" v-if="competition_id!=0">
                                    <a href="#member_tab_2"
                                       aria-controls="#member_tab_2"
                                       data-toggle="tab"
                                       aria-expanded="false">Compétiteurs Poomsae & résultats</a>
                                </li>
                                <li :class="" v-if="competition_id!=0">
                                    <a href="#member_tab_3"
                                       aria-controls="#member_tab_2"
                                       data-toggle="tab"
                                       aria-expanded="false">Arbitres Poomsae</a>
                                </li>

                                <li :class="{ 'active': competition_id==0 }">
                                    <a href="#member_tab_4"
                                       aria-controls="#member_tab_4"
                                       data-toggle="tab"
                                       aria-expanded="false">Listing des compétitions Poomsae</a>
                                </li>

                                <li class="pull-right">
                                    <a @click.prevent="showModalNewCompetition()">Ajouter une compétition Poomsae</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row tab-content">
                    <div v-if="competition_id!=0" role="tabpanel" class="col-md-12 tab-pane"
                         :class="{ 'active': competition_id!=0 }" id="member_tab_1">
                        <MainFormCompetitionPoomsae
                                v-if="competition_id!=0"
                                :loadingTableMembres="loading"
                                @onNeedRefreshCompetition="refreshCompetition()"
                        ></MainFormCompetitionPoomsae>
                    </div>
                    <div v-if="competition_id!=0" role="tabpanel" class="col-md-12 tab-pane"
                         :class="" id="member_tab_2">
                        <InscriptionsResultatsPoomsae
                        v-if="competition_id!=0"
                        ></InscriptionsResultatsPoomsae>
                    </div>
                    <div v-if="competition_id!=0" role="tabpanel" class="col-md-12 tab-pane"
                         :class="" id="member_tab_3">
                        <InscriptionsArbitresPoomsae
                        v-if="competition_id!=0"
                        ></InscriptionsArbitresPoomsae>
                    </div>

                    <div role="tabpanel" class="col-md-12 tab-pane" :class="{ 'active': competition_id==0 }" id="member_tab_4">
                        <ListingCompetitionPoomsae>
                        </ListingCompetitionPoomsae>
                    </div>

                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import MainFormCompetitionPoomsae from './MainFormCompetitionPoomsae.vue'
    import ModalNewCompetitionPoomsae from './ModalNewCompetitionPoomsae'
    import ListingCompetitionPoomsae from './ListingCompetitionPoomsae'
    import InscriptionsResultatsPoomsae from "./InscriptionsResultatsPoomsae";
    import InscriptionsArbitresPoomsae from "./InscriptionsArbitresPoomsae";

    export default {
        data() {
            return {

                loading: false,
                competition_id: null
            }
        },
        props: {},
        computed: {
            ...mapGetters({
                getCompetitionPoomsae: 'getCompetitionPoomsae',
                getNiveauxCompetitionPoomsae: 'getNiveauxCompetitionPoomsae',
                getRoute: 'getRoute',
                getCategAgePoomsae: 'getCategAgePoomsae',
                getCategGradePoomsae: 'getCategGradePoomsae',
            })
        },
        methods: {
            ...mapActions({
                setCompetitionPoomsae: 'setCompetitionPoomsae',
                setNiveauxCompetitionPoomsae: 'setNiveauxCompetitionPoomsae',
                setListeCompetitionPoomsae: 'setListeCompetitionPoomsae',
                setCategAgePoomsae: 'setCategAgePoomsae',
                setCategGradePoomsae: 'setCategGradePoomsae',
            }),

            showModalNewCompetition: function () {
                $('#modalNewCompetition').modal()
            },
            refreshCompetition: function () {
                return this.loadCompetition();
            },
            loadingComplete: function () {
                return this.competition_id == 0 ? true :
                    (this.getCompetitionPoomsae != null && this.getNiveauxCompetitionPoomsae != null)
            },
            loadNiveauxCompetitionPoomsae: function () {
                this.$http.get(this.getRoute('getAllNiveauxCompetitionPoomsae')).then((response) => {
                    this.setNiveauxCompetitionPoomsae(response.body)
                }, (response) => {
                });
            },
            loadCategAgeCompetitionPoomsae: function () {
                this.$http.get(this.getRoute('getAllAgeCompetitionPoomsae')).then((response) => {
                    this.setCategAgePoomsae(response.body)
                }, (response) => {
                });
            },
  
            loadCategGradeCompetitionPoomsae: function () {
                this.$http.get(this.getRoute('getAllGradeCompetitionPoomsae')).then((response) => {
                    this.setCategGradePoomsae(response.body)
                }, (response) => {
                });
            },
            loadListeCompetitionPoomsae: function () {
                this.$http.get(this.getRoute('getAllCompetitionsPoomsae')).then((response) => {
                    this.setListeCompetitionPoomsae(response.body)
                }, (response) => {
                });
            },
            loadCompetitionPoomsae: function () {
                this.loading = true
                if (this.competition_id == 0)
                    return;
                this.$http.get(this.getRoute('Secretariat.getInfosCompetitionPoomsae') + this.competition_id)
                    .then((response) => {
                        this.setCompetitionPoomsae(response.body)
                        this.loading = false
                    }, (response) => {
                        this.loading = false
                        this.setCompetitionPoomsae(null)
                    });
            },
        },
        beforeRouteUpdate(to, from, next) {
            this.competition_id = to.params.competition_id;
            // console.log("Update to " + this.competition_id)
            this.setCompetitionPoomsae(null)
            this.loadNiveauxCompetitionPoomsae()
            this.loadListeCompetitionPoomsae()
            this.loadCompetitionPoomsae()
            this.loadCategAgeCompetitionPoomsae()
            this.loadCategGradeCompetitionPoomsae()
            next()

        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.competition_id = vm.$route.params.competition_id
                vm.setCompetitionPoomsae(null)
                vm.loadNiveauxCompetitionPoomsae()
                vm.loadListeCompetitionPoomsae()
                vm.loadCompetitionPoomsae()
                vm.loadCategAgeCompetitionPoomsae()
                vm.loadCategGradeCompetitionPoomsae()
            })
        },
        watch: {},
        components: {
            InscriptionsArbitresPoomsae,
            InscriptionsResultatsPoomsae,
            MainFormCompetitionPoomsae,
            ModalNewCompetitionPoomsae,
            ListingCompetitionPoomsae,
            InscriptionsResultatsPoomsae,
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/CompetitionPoomsae/AppCompetitionPoomsae.vue